import React, { useState, useEffect } from 'react';

function AttendanceList({ zoneId, zoneName, onClose, onViewDate, canDelete }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterShift, setFilterShift] = useState('all');

  const fetchList = () => {
    setLoading(true);
    fetch(`/api/attendance/list?zone_id=${zoneId}`)
      .then((r) => r.json())
      .then((data) => {
        setList(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchList();
  }, [zoneId]);

  const filtered =
    filterShift === 'all'
      ? list
      : list.filter((r) => r.shift === filterShift);

  // ✅ ПРАВИЛЬНО: берём строку YYYY-MM-DD и формируем DD.MM.YYYY
  const formatDate = (d) => {
    if (!d) return '—';
    const dateOnly = d.toString().split('T')[0]; // "2026-10-01"
    const [year, month, day] = dateOnly.split('-');
    return `${day}.${month}.${year}`; // "01.10.2026"
  };

  // ✅ ПРАВИЛЬНО: только строка YYYY-MM-DD, без парсинга
  const getDateOnly = (d) => {
    if (!d) return '';
    return d.toString().split('T')[0];
  };

  const handleDelete = async (row, e) => {
    e.stopPropagation();

    const dateStr = formatDate(row.date);
    const shiftStr = row.shift === 'day' ? '☀️ День' : '🌙 Ночь';

    if (!window.confirm(
      `Удалить отчёт за ${dateStr} (${shiftStr})?\n\nБудут удалены все отметки сотрудников этой зоны за эту дату и смену.\n\nДействие необратимо.`
    )) return;

    try {
      const token = localStorage.getItem('token');
      const dateOnly = getDateOnly(row.date);

      const res = await fetch(
        `/api/attendance/${dateOnly}/${row.shift}?zone_id=${zoneId}`,
        {
          method: 'DELETE',
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (!res.ok) throw new Error('Ошибка удаления');

      fetchList();
    } catch (err) {
      alert('Ошибка: ' + err.message);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>📅 Отчёты по зоне «{zoneName}»</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          <div className="attendance-list-filters">
            <label>Смена:</label>
            <select
              className="filter-select"
              value={filterShift}
              onChange={(e) => setFilterShift(e.target.value)}
            >
              <option value="all">Все</option>
              <option value="day">☀️ День</option>
              <option value="night">🌙 Ночь</option>
            </select>
          </div>

          {loading ? (
            <div className="empty" style={{ padding: '30px' }}>⏳ Загрузка...</div>
          ) : filtered.length === 0 ? (
            <div className="empty" style={{ padding: '30px' }}>
              Нет сохранённых отчётов
            </div>
          ) : (
            <table className="table">
              <thead>
  <tr>
    <th style={{ width: '120px' }}>Дата</th>
    <th style={{ width: '100px' }}>Смена</th>
    <th>Явка</th>
    <th style={{ width: '160px' }}>План</th>
    <th style={{ width: canDelete ? '220px' : '120px' }}></th>
  </tr>
</thead>
              <tbody>
  {filtered.map((row, idx) => (
    <tr key={idx}>
      <td><b>{formatDate(row.date)}</b></td>
      <td>
        {row.shift === 'day' ? '☀️ День' : '🌙 Ночь'}
      </td>
      <td>
        <span className="sum-item sum-work">✅ {row.work_count}</span>
        {parseInt(row.sick_count) > 0 && (
          <span className="sum-item sum-sick">🤒 {row.sick_count}</span>
        )}
        {parseInt(row.absent_count) > 0 && (
          <span className="sum-item sum-absent">❌ {row.absent_count}</span>
        )}
        {parseInt(row.dayoff_count) > 0 && (
          <span className="sum-item sum-dayoff">🏖 {row.dayoff_count}</span>
        )}
        {parseInt(row.vacation_count) > 0 && (
          <span className="sum-item sum-vacation">🌴 {row.vacation_count}</span>
        )}
      </td>
      <td>
        {row.plan_amount !== null && row.plan_amount !== undefined ? (
          <span className="plan-cell">
            📦 {new Intl.NumberFormat('ru-RU').format(row.plan_amount)}
          </span>
        ) : (
          <span style={{ color: '#adb5bd', fontSize: '12px' }}>—</span>
        )}
      </td>
      <td>
        <div className="report-actions">
          <button
            className="btn-open-report"
            onClick={() => {
              onClose();
              const dateOnly = row.date.toString().split('T')[0];
              onViewDate(dateOnly, row.shift);
            }}
          >
            📋 Открыть
          </button>
          {canDelete && (
            <button
              className="btn-delete-report"
              onClick={(e) => handleDelete(row, e)}
              title="Удалить отчёт"
            >
              🗑
            </button>
          )}
        </div>
      </td>
    </tr>
  ))}
</tbody>
            </table>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-footer-right">
            <button className="btn-cancel" onClick={onClose}>Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceList;